import { IUseVirtualTourContext } from "@helper/react-context/context-hooks/use-virtual-tour-context";
import { Context } from "@helper/react-context/context-provider";
import { useContext } from "react";

const useVirtualTour = (): IUseVirtualTourContext => useContext(Context).virtualTour;

export default useVirtualTour;
